import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as PhIcons from "@phosphor-icons/react";
import { api } from "../lib/api";
import KoshMark from "../components/KoshMark";

export default function SolutionsAtlas() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/atlas").then(({ data }) => setItems(data)).catch(() => {});
  }, []);

  return (
    <div data-testid="solutions-atlas-page" className="px-6 md:px-14 py-16 md:py-24">
      <div className="max-w-6xl">
        <div className="text-overline mb-4">◢ Solutions atlas</div>
        <h1 className="font-display font-bold tracking-tighter text-4xl sm:text-5xl lg:text-6xl text-white leading-[1]">
          Every module, <span className="text-[#FF4500]">mapped</span>.
        </h1>
        <p className="mt-5 text-[#8E8E93] max-w-2xl text-[15px]">
          A capability map of Wisewit's execution layer. Each square is a deployable module.
        </p>
      </div>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#2A2A2A] border border-[#2A2A2A]">
        {items.map((s, idx) => {
          const Icon = PhIcons[s.icon] || PhIcons.Stack;
          return (
            <div key={s.id} data-testid={`atlas-${s.id}`} className="bg-[#050505] p-8 hover:bg-[#0a0a0a] transition-colors ww-trace group">
              <div className="flex items-center justify-between">
                <Icon size={22} color={s.color} weight="duotone" />
                <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#555]">
                  {String(idx + 1).padStart(2, "0")} / {items.length}
                </span>
              </div>
              <div className="mt-6 font-display text-xl text-white">{s.title}</div>
              <ul className="mt-4 space-y-2">
                {s.bullets.map((b) => (
                  <li key={b} className="text-sm text-[#8E8E93] flex items-start gap-2">
                    <span className="w-1 h-1 rounded-full mt-2 flex-shrink-0" style={{ background: s.color }} />
                    <span>{b}</span>
                  </li>
                ))}
              </ul>

              {/* Ask KOSH about this — deep-dive without leaving the page */}
              <button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  window.dispatchEvent(new CustomEvent("kosh:open", { detail: { seed: `Tell me more about ${s.title} — where do we deploy it and what's the typical stack?` } }));
                }}
                data-testid={`atlas-ask-kosh-${s.id}`}
                className="mt-5 inline-flex items-center gap-2 font-mono text-[10px] tracking-[0.22em] uppercase text-[#8E8E93] hover:text-[#FF4500] transition-colors"
              >
                <KoshMark size={12} tone="on-glass" />
                Ask KOSH about this
              </button>
            </div>
          );
        })}
      </div>

      <div className="mt-14 flex flex-wrap gap-4">
        <Link to="/contact" className="btn-primary">Scope a module →</Link>
        <Link to="/reels" className="btn-secondary">See modules in motion</Link>
      </div>
    </div>
  );
}
